// Dashboard.js
import React, { useState,useEffect } from 'react';
import Sidebar from '../AdminLayout/Sidebar';
import Topbar from '../AdminLayout/TopBar';
import Chart from 'react-apexcharts';
import AboutPage from './../../LandingPage/AboutPage';
import { Table } from 'react-bootstrap';
import AppointmentList from './AppointmentList';
import Operations from './Operations'
import axios from 'axios';
import { API_PATH } from '../../Constant/constants';

const Dashboard = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);

    const [error, setError] = useState(null);
    const [metrics, setMetrics] = useState({
    totalPatientsCount: 0,
    totalDoctorsCount: 0,
    totalStaffCount: 0,
    totalAppointmentsCount: 0,
  });

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const token = localStorage.getItem('token'); // Get token from localStorage
        const response = await axios.get(`${API_PATH}/admin/metrices`, {
          headers: {
            Authorization: `Bearer ${token}`, // Attach token to header
          },
        });
        setMetrics(response.data);
      } catch (error) {
        console.error('Error fetching metrics:', error);

        if (error.response?.status === 403) {
          setError('Access denied. You do not have permission to view metrics.');
        } else {
          setError('An error occurred while fetching data.');
        }
      }
    };

    fetchMetrics();
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  // const chartOptions = {
  //   chart: {
  //     id: 'chart',
  //     sparkline: { enabled: true },
  //   },
  //   stroke: { curve: 'smooth' },
  //   fill: {
  //     type: 'gradient',
  //     gradient: {
  //       shadeIntensity: 1,
  //       opacityFrom: 0.7,
  //       opacityTo: 0.9,
  //     },
  //   },
  //   xaxis: {
  //     categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  //   },
  //   tooltip: {
  //     enabled: true,
  //     theme: 'dark',
  //   },
  // };



    const chartOptions = {
    chart: {
      id: 'basic-area',
      sparkline: {
        enabled: true,
      },
    },
    xaxis: {
      categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    },
    stroke: {
      curve: 'smooth',
    },
    tooltip: {
      enabled: false,
    },
  };
  const appointmentData = [
    { id: 1, name: 'John Doe', date: '2025-03-01', time: '10:00 AM', status: 'Confirmed' },
    { id: 2, name: 'Jane Smith', date: '2025-03-01', time: '11:30 AM', status: 'Pending' },
    { id: 3, name: 'Alice Johnson', date: '2025-03-02', time: '09:00 AM', status: 'Completed' },
    { id: 4, name: 'Michael Brown', date: '2025-03-02', time: '01:00 PM', status: 'Cancelled' },
    { id: 5, name: 'Emily Davis', date: '2025-03-03', time: '02:30 PM', status: 'Confirmed' },
  ];

  return (
    <div className="d-flex h-100" >
    
      <div className={`flex-grow-1 ${isSidebarOpen ? 'ms-1' : 'ms-2'}`}>
        {/* <Topbar toggleSidebar={toggleSidebar} /> */}
        <div className="container p-4" >
          <div class="card-body mh-190">

                   
                    {/* <div class="row gx-3">
                      <div class="col-sm-9">
                        <div class="text-primary">
                          <h4>Dr. Laura Jaden</h4>
                          <h6 class="fw-normal">Dentist, BDS, BChD</h6>
                          <div>
                            Increased patients by <span class="fw-bold">90</span> in the last Seven days.
                          </div>
                          <a href="book-appointment.html" class="btn btn-primary mt-3">
                            Book Appointment
                          </a>
                        </div>
                      </div>
                    </div>
                    */}

                  </div>
          {/* <div className="row">
          
            <div className="col-md-3 mb-4">
              <div className="card card-statistic-2">
                <div className="clearfix">
                  <div className="card-icon shadow-primary bg-purple">
                    <i className="material-icons align-middle">face</i>
                  </div>
                  <div className="card-right">
                    <p className="float-end font-b-500">Appointments</p>
                    <div className='m-r-10 m-l-10'>
                    <h6 className="font-weight-bold float-end mb-0">650</h6>
                    </div>
                  </div>
                </div>
                <div className="chart-container">
                  <Chart
                    options={{
                      ...chartOptions,
                      colors: ['#6f42c1'],
                    }}
                    series={[{ name: 'Appointments', data: [50, 70, 65, 90, 80, 85, 100] }]}
                    type="area"
                    height={70}
                  />
                </div>
              </div>
            </div>

    
            <div className="col-md-3 mb-4">
              <div className="card card-statistic-2">
                <div className="clearfix">
                  <div className="card-icon shadow-primary bg-info">
                    <i className="material-icons align-middle">people</i>
                  </div>
                  <div className="card-right">
                    <p className="float-end font-b-500">Patients</p>
                    <div className='m-r-10 m-l-10'>
                    <h6 className="font-weight-bold float-end mb-0">1200</h6>
                    </div>
                  </div>
                </div>
                <div className="chart-container">
                  <Chart
                    options={{
                      ...chartOptions,
                      colors: ['#17a2b8'],
                    }}
                    series={[{ name: 'Patients', data: [30, 50, 45, 60, 55, 70, 90] }]}
                    type="area"
                    height={70}
                  />
                </div>
              </div>
            </div>

          
            <div className="col-md-3 mb-4">
              <div className="card card-statistic-2">
                <div className="clearfix">
                  <div className="card-icon shadow-primary bg-success">
                    <i className="material-icons align-middle">groups</i>
                  </div>
                  <div className="card-right">
                    <p className="float-end font-b-500">Staff</p>
                    <div className='m-r-10 m-l-10'>
                    <h6 className="font-weight-bold float-end mb-0">150</h6>
                    </div>
                  </div>
                </div>
                <div className="chart-container">
                  <Chart
                    options={{
                      ...chartOptions,
                      colors: ['#28a745'],
                    }}
                    series={[{ name: 'Staff', data: [20, 30, 25, 40, 35, 50, 60] }]}
                    type="area"
                    height={70}
                  />
                </div>
              </div>
            </div>

         
            <div className="col-md-3 mb-4">
              <div className="card card-statistic-2">
                <div className="clearfix">
                  <div className="card-icon shadow-primary bg-warning">
                    <i className="material-icons align-middle">medical_services</i>
                  </div>
                  <div className="card-right">
                    <p className="float-end font-b-500">Doctors</p>
                  <div className='m-r-10 m-l-10'>
                    <h6 className="font-weight-bold float-end mb-0">80</h6>
                    </div>
                  </div>
                </div>
                <div className="chart-container">
                  <Chart
                    options={{
                      ...chartOptions,
                      colors: ['#ffc107'],
                    }}
                    series={[{ name: 'Doctors', data: [10, 15, 20, 25, 30, 35, 40] }]}
                    type="area"
                    height={70}
                  />
                </div>
              </div>
            </div>

           <AppointmentList/>
          
          </div> */}


 <div className="row">
      {/* Appointments Card */}
      <div className="col-md-3 mb-4">
        <div className="card card-statistic-2">
          <div className="clearfix">
            <div className="card-icon shadow-primary bg-purple">
              <i className="material-icons align-middle">face</i>
            </div>
            <div className="card-right">
              <p className="float-end font-b-500">Appointments</p>
              <div className="m-r-10 m-l-10">
                <h6 className="font-weight-bold float-end mb-0">{metrics.totalAppointmentsCount}</h6>
              </div>
            </div>
          </div>
          <div className="chart-container">
            <Chart
              options={{ ...chartOptions, colors: ['#6f42c1'] }}
              series={[{ name: 'Appointments', data: [50, 70, 65, 90, 80, 85, 100] }]}
              type="area"
              height={70}
            />
          </div>
        </div>
      </div>

      {/* Patients Card */}
      <div className="col-md-3 mb-4">
        <div className="card card-statistic-2">
          <div className="clearfix">
            <div className="card-icon shadow-primary bg-info">
              <i className="material-icons align-middle">people</i>
            </div>
            <div className="card-right">
              <p className="float-end font-b-500">Patients</p>
              <div className="m-r-10 m-l-10">
                <h6 className="font-weight-bold float-end mb-0">{metrics.totalPatientsCount}</h6>
              </div>
            </div>
          </div>
          <div className="chart-container">
            <Chart
              options={{ ...chartOptions, colors: ['#17a2b8'] }}
              series={[{ name: 'Patients', data: [30, 50, 45, 60, 55, 70, 90] }]}
              type="area"
              height={70}
            />
          </div>
        </div>
      </div>

      {/* Staff Card */}
      <div className="col-md-3 mb-4">
        <div className="card card-statistic-2">
          <div className="clearfix">
            <div className="card-icon shadow-primary bg-success">
              <i className="material-icons align-middle">groups</i>
            </div>
            <div className="card-right">
              <p className="float-end font-b-500">Staff</p>
              <div className="m-r-10 m-l-10">
                <h6 className="font-weight-bold float-end mb-0">{metrics.totalStaffCount}</h6>
              </div>
            </div>
          </div>
          <div className="chart-container">
            <Chart
              options={{ ...chartOptions, colors: ['#28a745'] }}
              series={[{ name: 'Staff', data: [20, 30, 25, 40, 35, 50, 60] }]}
              type="area"
              height={70}
            />
          </div>
        </div>
      </div>

      {/* Doctors Card */}
      <div className="col-md-3 mb-4">
        <div className="card card-statistic-2">
          <div className="clearfix">
            <div className="card-icon shadow-primary bg-warning">
              <i className="material-icons align-middle">medical_services</i>
            </div>
            <div className="card-right">
              <p className="float-end font-b-500">Doctors</p>
              <div className="m-r-10 m-l-10">
                <h6 className="font-weight-bold float-end mb-0">{metrics.totalDoctorsCount}</h6>
              </div>
            </div>
          </div>
          <div className="chart-container">
            <Chart
              options={{ ...chartOptions, colors: ['#ffc107'] }}
              series={[{ name: 'Doctors', data: [10, 15, 20, 25, 30, 35, 40] }]}
              type="area"
              height={70}
            />
          </div>
        </div>
      </div>

      <AppointmentList />
    </div>

        </div>
      </div>
     
        
    </div>
  );
};

export default Dashboard;
